import * as React from 'react';
import styled from 'styled-components';
import { Row, RowProps } from 'react-flexbox-grid';

const StyledRow = styled(Row)<RowProps>`
  padding-left: ${props => `${props.theme.gridGutter}px` || '8px'};
  padding-right: ${props => `${props.theme.gridGutter}px` || '8px'};
`;

export default (props: any) => <StyledRow {...props}>{props.children}</StyledRow>;



// WEBPACK FOOTER //
// ./src/components/primitives/Row.tsx